import React from "react";
import Help, { ARTICLES } from "../../../../components/help/Help";
import { ActionDeflection } from "../../../../__generated__/api";

interface Props {
    action: ActionDeflection;
}

export default function Deflection(props: Props) {
    return (
        <div>
            {props.action.isSuccessful ? (
                <>
                    <h4 className="text-center w-100 mb-4">
                        🎉 Thanks for providing this feedback!
                    </h4>

                    <div className="list-group list-group-horizontal w-100 flex-wrap">
                        This feedback will be used to train our AI to focus on the imporatnt answers
                        and display less bad answers. By submitting this feedback, you are helping future
                        users with the same question!
                    </div>
                </>
            ) : (
                <>
                    <h4 className="text-center w-100 mb-4">
                        👎 Sorry, we will dispatch an agent to help.
                    </h4>

                    <div className="list-group list-group-horizontal w-100 flex-wrap">
                        We have noted that this answer was help helpful. We will let someone
                        know and they will get back to you soon!
                    </div>
                </>
            )}

            <div className="text-end w-100">
                <Help
                    articleId={ARTICLES.ACTIONS_DEFLECTION}
                    buttonClassName="btn btn-none text-light mx-auto"
                    buttonType="help"
                />
            </div>

        </div>
    );
}
